<template>
    <div class="assets">
        <empty type="clock" title="Time is money and money is good, right?">
            <div class="badge badge--warning">Coming Soon!</div>
        </empty>
    </div>
</template>

<script>
import Empty from '../Global/Empty'
export default {
    name: 'TimeTracking',

    components: {
        Empty
    }
}
</script>
